import { type BaseApiErrorResponse, HttpStatus } from '../types/api.types';
import BaseApiResponseError from './BaseApiResponseError';

export type ContentTooLargeErrorArgs<TErrors> = Omit<
  BaseApiErrorResponse<TErrors>,
  'errors' | 'status'
>;
export default class ContentTooLargeError<
  TErrors,
> extends BaseApiResponseError<TErrors> {
  constructor({ code, message }: ContentTooLargeErrorArgs<TErrors>) {
    super({ code, errors: null, message, status: HttpStatus.ContentTooLarge });
  }
}
